"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.TriggerButtonBase = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var component_library_1 = require("@kaizen/component-library");
var chevron_down_icon_svg_1 = __importDefault(require("@kaizen/component-library/icons/chevron-down.icon.svg"));
var chevron_up_icon_svg_1 = __importDefault(require("@kaizen/component-library/icons/chevron-up.icon.svg"));
var MenuTriggerProvider_1 = require("../../../provider/MenuTriggerProvider");
var TriggerButtonBase_module_scss_1 = __importDefault(require("./TriggerButtonBase.module.scss"));
var TriggerButtonBase = function (_a) {
    var children = _a.children, classNameOverride = _a.classNameOverride;
    var _b = (0, MenuTriggerProvider_1.useMenuTriggerContext)(), buttonProps = _b.buttonProps, buttonRef = _b.buttonRef, menuTriggerState = _b.menuTriggerState;
    return (react_1["default"].createElement("button", __assign({ type: "button" }, buttonProps, { ref: buttonRef, className: (0, classnames_1["default"])(TriggerButtonBase_module_scss_1["default"].button, classNameOverride) }),
        children,
        react_1["default"].createElement(component_library_1.Icon, { icon: menuTriggerState.isOpen ? chevron_up_icon_svg_1["default"] : chevron_down_icon_svg_1["default"], role: "presentation", classNameOverride: TriggerButtonBase_module_scss_1["default"].icon })));
};
exports.TriggerButtonBase = TriggerButtonBase;
exports.TriggerButtonBase.displayName = "TriggerButtonBase";
//# sourceMappingURL=TriggerButtonBase.js.map